export default function PhaseScheduleBanner({ mode }) {
  const isImport = mode === 'import';

  return (
    <div className="eod-phase-banner">
      <div className="eod-phase-banner-title">
        <i className="bi bi-clock-history" />{' '}
        {isImport ? 'Recommended Phased Import Schedule (runs after downloads)' : 'Recommended Cron / Pipeline Schedule'}
      </div>
      <table className="eod-phase-table">
        <thead>
          <tr>
            <th>{isImport ? 'Phase' : 'Pipeline Phase'}</th>
            <th>{isImport ? 'Target Time (IST)' : 'Target Execution Time (IST)'}</th>
            <th>{isImport ? 'Data Imported' : 'Data Sources Fetched'}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><b>{isImport ? 'Phase 1' : 'Phase 1 (Equities & Spot)'}</b></td>
            <td>{isImport ? 'chained after Phase 1 DL (+ safety 16:40 / 17:30)' : '4:30 PM (retries → 8:00 PM IST)'}</td>
            <td>EQ Bhav, FO Bhav, Index Spot (NSE/BSE) → eod-oc / eod-chart</td>
          </tr>
          <tr>
            <td><b>{isImport ? 'Phase 2' : 'Phase 2 (Derived & Web)'}</b></td>
            <td>{isImport ? 'chained after Phase 2 DL' : '4:45 PM (retries → 7:00 PM IST)'}</td>
            <td>{isImport ? 'FO Volatility' : 'FO Volatility, Moneycontrol FII/DII Cash'}</td>
          </tr>
          <tr>
            <td><b>{isImport ? 'Phase 3' : 'Phase 3 (Participant & FII)'}</b></td>
            <td>{isImport ? 'chained after Phase 3 DL (+ safety nets)' : '6:30 PM (retries → 10:00 PM IST)'}</td>
            <td>FII Stats, Participant OI, Participant VOL → participant</td>
          </tr>
        </tbody>
      </table>
      <div className="eod-phase-foot">
        {isImport
          ? 'Phased crons match the download schedule in EOD Sync. Use Phase buttons for manual runs. Phase 1 feeds /obsidian/eod-oc and /eod-chart; Phase 3 feeds /obsidian/participant.'
          : 'Crons chain download → import per phase. Phase 1 powers /obsidian/eod-oc and /eod-chart; Phase 3 powers /obsidian/participant. All phases retry until files appear or cutoff.'}
      </div>
    </div>
  );
}